export const TypeAddressEnum = Object.freeze({
    province: "admin_level_2",
    district: "admin_level_3",
    subdistrict: "admin_level_4",
    hamlet: "hamlet",
    street: "street",
    houseNumber: "housenumber",
});
